import { Empty } from "antd"

export default function LeaderboardTable({ students, user }) {

  if (!students?.length) {
    return <Empty />
  }

  console.info({ students })

  return (
    <div className="my-8">
      <h3 className="text-lg font-bold">Top 20 Result</h3>
      <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
        <thead>
          <tr className="border-b border-slate-600/50">
            <th className="table-th !text-center">Rank</th>
            <th className="table-th !text-center">Name</th>
            <th className="table-th !text-center">Quiz Mark</th>
            <th className="table-th !text-center">Assignment Mark</th>
            <th className="table-th !text-center">Total</th>
          </tr>
        </thead>

        <tbody>
          {
            students?.map(student => (
              <tr className={`border-b border-slate-600/50 ${user.id == student.id ? 'bg-cyan-500 bg-opacity-50' : ''}`}>
                <td className={`table-td text-center`}>{student?.rank}</td>
                <td className={`table-td text-center`}>{student?.name}</td>
                <td className={`table-td text-center`}>{student?.quizMark}</td>
                <td className={`table-td text-center`}>{student?.assignmentMark}</td>
                <td className={`table-td text-center`}>{student?.totalObtainedMarks}</td>
              </tr>
            ))
          }

        </tbody>
      </table>
    </div>
  )
}